<template>
  <article>
    <section class="xbed-sub-title">
      <span>{{title}}</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Row>
        <Col span="4">
          <Input v-model="searchCityName" placeholder="请输入查询内容" icon="ios-search" @on-enter="queryWithKeyword" @on-click="queryWithKeyword"></Input>
        </Col>

        <Col span="2" offset="1">
          <Button type="info" @click="openAddModal('create')">新增</Button>
        </Col>
      </Row>

    </section>

    <section style="margin-top:20px">
      <Table stripe :columns="columns" :data="data"></Table>
    </section>
    <section style="margin: 10px;overflow: hidden">
      <div style="float: left;">
        <Page show-sizer :total="count" :current="page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
    </section>

    <Modal v-model="addModal.display" :title="addModal.title"  ref="hotCityModal" :loading="modalLoading" @on-ok="preAddHotCity" @on-cancel="cancelAddHotCity">
      <Form v-model="addModal.data" :label-width="80">
        <FormItem v-show="addModal.action === 'create'" label="名称" prop="cityName">
          <Select v-model="addModal.data.cityName" filterable>
            <Option v-for="item in addModal.notExistHotCities" :value="item.city" :key="item.city">{{item.city}}</Option>
          </Select>
        </FormItem>

        <FormItem v-show="addModal.action === 'update'" label="名称" prop="cityName">
          <Input v-model="addModal.data.cityName" disabled></Input>
        </FormItem>

        <FormItem label="状态" prop="status">
          <Select v-model="addModal.data.status">
            <Option v-bind:value='0'>关闭</Option>
            <Option v-bind:value='1'>开启</Option>
          </Select>
        </FormItem>

        <FormItem label="终端" prop="terminal">
          <RadioGroup v-model="addModal.data.terminal">
            <Radio label='0'>
              <span>所有</span>
            </Radio>
            <Radio label='1'>
              <span>微信</span>
            </Radio>
            <Radio label='2'>
              <span>iOS</span>
            </Radio>
            <Radio label='3'>
              <span>Android</span>
            </Radio>
          </RadioGroup>
        </FormItem>


        <FormItem label="权重值(0-500)" prop="sortNum">
          <InputNumber v-model="addModal.data.sortNum" :min="0" :max="500" :precision="0"></InputNumber>
        </FormItem>

      </Form>
      <hr>
      <img style="width:100%" :src="addModal.data.cityPicUrl" alt="">
      <Upload action="//upload.qiniup.com" name="file" :data="uploadData.form" :before-upload="beforeUpload" :on-success="uploadSuccess" :show-upload-list=false>
        <Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
      </Upload>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.query();
    this.$Notice.config({
      top: 100
    });
  },
  data() {
    return {
      title: "热门城市",
      columns: [
        {
          title: "id",
          key: "id",
          align: "center",
          width: 100
        },
        {
          title: "名称",
          key: "cityName",
          align: "center",
          width: 200
        },
        {
          title: "图片地址",
          key: "cityPicUrl",
          align: "center",
          width: 300,
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: params.row.cityPicUrl
              },
              style: {
                width: "300px",
                height: "200px"
              }
            });
          }
        },
        {
          title: "使用终端",
          key: "terminal",
          align: "center",
          width: 100,
          render: (h, params) => {
            const termTypes = ["所有", "微信", "iOS", "android", "小程序"];
            return h("span", {}, termTypes[params.row.terminal]);
          }
        },
        {
          title: "权重值",
          key: "sortNum",
          align: "center",
          width: 100
        },
        {
          title: "状态值",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            const row = params.row;
            const color = row.status === 1 ? "green" : "red";
            const text = row.status === 1 ? "开启" : "关闭";

            return h(
              "Tag",
              {
                props: {
                  type: "dot",
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.updateHotCity(params.index);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定删除 ${params.row.id} - ${params.row
                            .cityName} 吗？\n一经确定将无法修改`;
                          return modalH(
                            "div",
                            {
                              style: {
                                fontSize: "16px"
                              }
                            },
                            modalText
                          );
                        },
                        onOk: () => {
                          this.delHotCity(params.index);
                        }
                      });
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      loading: false,
      modalLoading: true,
      searchCityName: "",
      count: 0,
      pageCount: 0,
      page: 1,
      pageSize: 10,
      data: [],
      uploadData: {
        name: "",
        form: {}
      },
      addModal: {
        display: false,
        title: "新增热门城市",
        action: "",
        notExistHotCities: [],
        data: {
          cityName: "",
          cityPicUrl: "",
          status: 1,
          terminal: 0,
          sortNum: 0
        }
      }
    };
  },
  methods: {
    changePage(pageIndex) {
      this.page = pageIndex;
      this.query();
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.query();
    },
    queryWithKeyword() {
      this.page = 1;
      this.query();
    },
    async query() {
      this.loading = true;
      const resp = (await this.queryHotCityList()).data;
      this.data = resp.result;
      this.page = resp.page;
      this.pageSize = resp.pageSize;
      this.pageCount = resp.pageCount;
      this.count = resp.count;
      this.loading = false;
    },
    queryHotCityList() {
      return API.omsAPI[this.env].advert.queryHotCityList(
        this.page,
        this.pageSize,
        this.searchCityName,
        this.token
      );
    },
    async openAddModal(action) {
      this.addModal.display = true;
      if (action === "create") {
        this.addModal.data.createName = this.username;
        this.addModal.action = action;
        this.addModal.title = "新增热门城市";

        // 查询不存在热门城市表的城市列表
        const cities = (await API.omsAPI[this.env].advert.queryNotExistHotCity(
          this.token
        )).data;

        this.addModal.notExistHotCities = cities;

        if (cities.length > 1) {
          this.addModal.data.cityName = cities[0].city;
        }
      }

      if (action === "update") {
        this.addModal.data.updateName = this.username;
        this.addModal.action = action;
        this.addModal.title = "修改热门城市";
      }
    },
    async preAddHotCity() {
      if (this.addModal.action === "create") {
        if (Object.keys(this.uploadData.form).length == 0) {
          this.$Notice.error({
            title: "添加热门城市失败",
            desc: "请添加图片"
          });
          // 保持modal，重置确定按钮
          this.$refs.hotCityModal.buttonLoading = false;
          return;
        }
        let resp = (await API.omsAPI[this.env].advert.addHotCity(
          this.addModal.data,
          this.token
        )).data;

        if (resp.retCode) {
          // 错误警告
          this.$Notice.error({
            title: "添加热门城市失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "添加热门城市成功"
          });
          this.refreshTable();
        }
      } else if (this.addModal.action === "update") {
        let resp = (await API.omsAPI[this.env].advert.editHotCity(
          this.addModal.data,
          this.token
        )).data;

          if (resp.retCode) {
            // 错误警告
            this.$Notice.error({
              title: "修改热门城市失败",
              desc: resp.msg
            });
          } else {
            this.$Notice.success({
              title: "修改热门城市成功"
            });
            this.refreshTable();
          }
        }
        // 手动关闭modal
        this.addModal.display = false;
        // 重置addModal data
        this.resetAddModalData();
    },
    cancelAddHotCity() {
      // 重置addModal data
      this.resetAddModalData();
    },
    resetAddModalData() {
      this.addModal.data = {
        cityName: "",
        cityPicUrl: "",
        status: "1",
        terminal: "0",
        sortNum: 0
      };
    },
    refreshTable() {
      this.count = 0;
      this.pageCount = 0;
      this.page = 1;
      this.query();
    },
    async updateHotCity(index) {
      let hotCity = this.data[index];
      this.addModal.data = {
        id: hotCity.id,
        cityName: hotCity.cityName,
        cityPicUrl: hotCity.cityPicUrl,
        status: hotCity.status,
        terminal: hotCity.terminal,
        sortNum: hotCity.sortNum
      };
      this.openAddModal("update");
    },
    async delHotCity(index) {
      let id = this.data[index].id;
      let resp = (await API.omsAPI[this.env].advert.delHotCity(
        id,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "删除热门城市失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除热门城市成功"
        });
        this.data.splice(index, 1);
      }
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`);
      let token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token))
        .data;
      this.uploadData.form.token = token;

      // this.advertForm.uploadData.token = token
      this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
      this.uploadData.form["x:fileDirId"] = 636;
      this.uploadData.form["x:isPrivate"] = 0;
      this.uploadData.form["x:remark"] = "新增广告图";
      return true;
    },
    uploadSuccess(resp) {
      this.addModal.data.cityPicUrl = resp.materialBase.url;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/advert/hot-city.vue